import { GetEmpreendimentosService } from '@/features/empreendimentos/services/get-empreendimentos.service'
import { empreendimentosKeys } from '@/features/empreendimentos/utils'
import { usePrefetch } from '@/hooks/use-prefetch'

export const usePrefetchEmpreendimentos = () => {
  return usePrefetch({
    queryKey: empreendimentosKeys.lista({}),
    queryFn: () => new GetEmpreendimentosService().execute({}).then((response) => response.data),
    staleTime: 60 * 1000 * 5,
  })
}
